import { useCallback, useState } from 'react'

import { DEFAULT_DEBOUNCED_DELAY } from 'src/constants'

import { useDebounce } from 'src/hooks/useDebounce'

export const useDebounceState = (
  defaultValue = '',
  debounceDelay = DEFAULT_DEBOUNCED_DELAY,
) => {
  const [currentValue, setCurrentValue] = useState(defaultValue)
  const [debouncedValue, setCurrentDebouncedValue] = useState(defaultValue)

  const { callback: setDebouncedValue } = useDebounce(
    setCurrentDebouncedValue,
    debounceDelay,
  )

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      const text = event.target.value
      setCurrentValue(text)
      setDebouncedValue(text)
    },
    [setDebouncedValue, setCurrentValue],
  )

  return [
    currentValue,
    debouncedValue,
    handleChange,
    setCurrentDebouncedValue,
    setCurrentValue,
  ] as const
}
